import { createStore as reduxCreateStore } from "redux"

import reducer from "./reducer"
import initialState from "./initialState"


const createStore = () =>
  reduxCreateStore(reducer, initialState)
export default createStore
